$(document).ready(function(){
    if ( !window.location.hostname.includes('playguidetour') && !window.location.hostname.includes('divenavi') ){
        initHeaderFooter();
        getContact();
    }
});

function initHeaderFooter() {
    initOriginInput();
}

function initOriginInput() {
    $("#origin-input").on("change", function() {
        blockUI();
        
        var origin = $("#origin-input option:selected").val();
        $.ajax({
            type: "GET",
            url: "/ajax/origin/" + origin,
        }).done(function(data) {
            // 成功した場合はページをリロードして、設定した出発地でデータを再取得させる
            console.log("Origin Change Success");
            location.reload();
        }).fail(function (XMLHttpRequest, textStatus, errorThrown) {
            console.log("Origin Change Failed");
            unblockUI();
        });
    });
}

function getContact() {
    console.log("Get Contact");
    $.ajax({
        type: "GET",
        url: "/ajax/contact",
        dataType:'json'
    }).done(function(data) {
        // 成功した場合はユーザー名を表示
        $userDisplaySection = $("#user-display");
        $userDisplaySection.text("ようこそ " + data.last_name + data.first_name + "さん");
        $userDisplaySection.show();
    }).fail(function (XMLHttpRequest, textStatus, errorThrown) {
        console.log("Get Contact Failed");
    });
}

function blockUI() {
	$.blockUI({
		message: '<div class="loader">Loading...</div>',
		css: {'z-index': 2147483647},
		overlayCSS:{'z-index': 2147483646}
	});
}

function unblockUI() {
    $.unblockUI();
}